// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_PAGE_MARGIN_XS = '16px';
export const SYS_PAGE_MARGIN_SM = '28px';
export const SYS_PAGE_MARGIN_MD = '40px';
export const SYS_PAGE_MARGIN_LG = '60px';
export const SYS_PAGE_MARGIN_XL = '96px';
export const SYS_PAGE_MARGIN_2_XL = '96px';
export const SYS_SPACE_RELATIVE_BP_XS_2_XS = '4px';
export const SYS_SPACE_RELATIVE_BP_XS_XS = '8px';
export const SYS_SPACE_RELATIVE_BP_XS_SM = '12px';
export const SYS_SPACE_RELATIVE_BP_XS_MD = '16px';
export const SYS_SPACE_RELATIVE_BP_XS_LG = '24px';
export const SYS_SPACE_RELATIVE_BP_XS_XL = '28px';
export const SYS_SPACE_RELATIVE_BP_XS_2_XL = '36px';
export const SYS_SPACE_RELATIVE_BP_XS_3_XL = '40px';
export const SYS_SPACE_RELATIVE_BP_XS_4_XL = '48px';
export const SYS_SPACE_RELATIVE_BP_XS_5_XL = '64px';
export const SYS_SPACE_RELATIVE_BP_XS_6_XL = '80px';
export const SYS_SPACE_RELATIVE_BP_XS_7_XL = '96px';
export const SYS_SPACE_RELATIVE_BP_XS_8_XL = '120px';
export const SYS_SPACE_RELATIVE_BP_SM_2_XS = '4px';
export const SYS_SPACE_RELATIVE_BP_SM_XS = '8px';
export const SYS_SPACE_RELATIVE_BP_SM_SM = '12px';
export const SYS_SPACE_RELATIVE_BP_SM_MD = '16px';
export const SYS_SPACE_RELATIVE_BP_SM_LG = '24px';
export const SYS_SPACE_RELATIVE_BP_SM_XL = '28px';
export const SYS_SPACE_RELATIVE_BP_SM_2_XL = '36px';
export const SYS_SPACE_RELATIVE_BP_SM_3_XL = '40px';
export const SYS_SPACE_RELATIVE_BP_SM_4_XL = '48px';
export const SYS_SPACE_RELATIVE_BP_SM_5_XL = '64px';
export const SYS_SPACE_RELATIVE_BP_SM_6_XL = '80px';
export const SYS_SPACE_RELATIVE_BP_SM_7_XL = '96px';
export const SYS_SPACE_RELATIVE_BP_SM_8_XL = '120px';
export const SYS_SPACE_RELATIVE_BP_MD_2_XS = '4px';
export const SYS_SPACE_RELATIVE_BP_MD_XS = '8px';
export const SYS_SPACE_RELATIVE_BP_MD_SM = '12px';
export const SYS_SPACE_RELATIVE_BP_MD_MD = '16px';
export const SYS_SPACE_RELATIVE_BP_MD_LG = '24px';
export const SYS_SPACE_RELATIVE_BP_MD_XL = '28px';
export const SYS_SPACE_RELATIVE_BP_MD_2_XL = '36px';
export const SYS_SPACE_RELATIVE_BP_MD_3_XL = '48px';
export const SYS_SPACE_RELATIVE_BP_MD_4_XL = '64px';
export const SYS_SPACE_RELATIVE_BP_MD_5_XL = '72px';
export const SYS_SPACE_RELATIVE_BP_MD_6_XL = '88px';
export const SYS_SPACE_RELATIVE_BP_MD_7_XL = '104px';
export const SYS_SPACE_RELATIVE_BP_MD_8_XL = '136px';
export const SYS_SPACE_RELATIVE_BP_LG_2_XS = '4px';
export const SYS_SPACE_RELATIVE_BP_LG_XS = '8px';
export const SYS_SPACE_RELATIVE_BP_LG_SM = '12px';
export const SYS_SPACE_RELATIVE_BP_LG_MD = '16px';
export const SYS_SPACE_RELATIVE_BP_LG_LG = '24px';
export const SYS_SPACE_RELATIVE_BP_LG_XL = '28px';
export const SYS_SPACE_RELATIVE_BP_LG_2_XL = '40px';
export const SYS_SPACE_RELATIVE_BP_LG_3_XL = '56px';
export const SYS_SPACE_RELATIVE_BP_LG_4_XL = '72px';
export const SYS_SPACE_RELATIVE_BP_LG_5_XL = '88px';
export const SYS_SPACE_RELATIVE_BP_LG_6_XL = '104px';
export const SYS_SPACE_RELATIVE_BP_LG_7_XL = '128px';
export const SYS_SPACE_RELATIVE_BP_LG_8_XL = '168px';
export const SYS_SPACE_RELATIVE_BP_XL_2_XS = '4px';
export const SYS_SPACE_RELATIVE_BP_XL_XS = '8px';
export const SYS_SPACE_RELATIVE_BP_XL_SM = '12px';
export const SYS_SPACE_RELATIVE_BP_XL_MD = '16px';
export const SYS_SPACE_RELATIVE_BP_XL_LG = '24px';
export const SYS_SPACE_RELATIVE_BP_XL_XL = '32px';
export const SYS_SPACE_RELATIVE_BP_XL_2_XL = '56px';
export const SYS_SPACE_RELATIVE_BP_XL_3_XL = '72px';
export const SYS_SPACE_RELATIVE_BP_XL_4_XL = '88px';
export const SYS_SPACE_RELATIVE_BP_XL_5_XL = '104px';
export const SYS_SPACE_RELATIVE_BP_XL_6_XL = '120px';
export const SYS_SPACE_RELATIVE_BP_XL_7_XL = '160px';
export const SYS_SPACE_RELATIVE_BP_XL_8_XL = '216px';
export const SYS_SPACE_RELATIVE_BP2_XL_2_XS = '4px';
export const SYS_SPACE_RELATIVE_BP2_XL_XS = '8px';
export const SYS_SPACE_RELATIVE_BP2_XL_SM = '12px';
export const SYS_SPACE_RELATIVE_BP2_XL_MD = '16px';
export const SYS_SPACE_RELATIVE_BP2_XL_LG = '24px';
export const SYS_SPACE_RELATIVE_BP2_XL_XL = '40px';
export const SYS_SPACE_RELATIVE_BP2_XL_2_XL = '72px';
export const SYS_SPACE_RELATIVE_BP2_XL_3_XL = '88px';
export const SYS_SPACE_RELATIVE_BP2_XL_4_XL = '104px';
export const SYS_SPACE_RELATIVE_BP2_XL_5_XL = '120px';
export const SYS_SPACE_RELATIVE_BP2_XL_6_XL = '136px';
export const SYS_SPACE_RELATIVE_BP2_XL_7_XL = '176px';
export const SYS_SPACE_RELATIVE_BP2_XL_8_XL = '248px';
export const SYS_SPACE_FIXED_0 = '0px';
export const SYS_SPACE_FIXED_25 = '2px';
export const SYS_SPACE_FIXED_50 = '4px';
export const SYS_SPACE_FIXED_100 = '8px';
export const SYS_SPACE_FIXED_150 = '12px';
export const SYS_SPACE_FIXED_200 = '16px';
export const SYS_SPACE_FIXED_250 = '20px';
export const SYS_SPACE_FIXED_300 = '24px';
export const SYS_SPACE_FIXED_350 = '28px';
export const SYS_SPACE_FIXED_400 = '32px';
export const SYS_SPACE_FIXED_450 = '36px';
export const SYS_SPACE_FIXED_500 = '40px';
export const SYS_SPACE_FIXED_600 = '48px';
export const SYS_SPACE_FIXED_700 = '56px';
export const SYS_SPACE_FIXED_800 = '64px';
export const SYS_SPACE_FIXED_900 = '72px';
export const SYS_SPACE_FIXED_1000 = '80px';
export const SYS_SPACE_FIXED_1200 = '96px';
export const SYS_SPACE_FIXED_1600 = '128px';
export const SYS_SPACE_FIXED_2000 = '160px';
export const SYS_SPACE_FIXED_2200 = '176px';
export const SYS_SPACE_FIXED_2600 = '208px';
export const SYS_SPACE_UNDERLINE_OFFSET_100 = '2px';
export const SYS_SPACE_UNDERLINE_OFFSET_200 = '7px';
export const CMP_SPACE_NAVIGATION_STANDALONE_TEXT_LINK_UNDERLINE_OFFSET = '7px';
export const CMP_SPACE_UI_TAG_CLICKABLE_UNDERLINE_OFFSET = '2px';
//# sourceMappingURL=spacing.generated.js.map